/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Product Select Subscribers styles
 *
 * @author Yakov Gushchin
 * @version 1.10.0
 * @since 1.10.0
 */

import styled from 'styled-components';

import { fonts } from '../../../../theme';

export const ProductSelectSubscribersStyled = styled.div`
    margin-top: 32px;
`;

export const ProductSelectSubscribersInfoStyled = styled.div`
    margin-bottom: 24px;
    ${fonts.textMainBold}
`;

export const ProductSelectSubscribersRegionNoticeStyled = styled.div`
    display: flex;
    flex-grow: 1;
    justify-content: flex-end;

    .info-block {
        padding: 0;
    }
`;
